import React, { useRef, useState } from "react";
import { Dimmer } from "./spinner";
import Modal from "react-bootstrap/Modal";
import moment from "moment";
import { Mensaje } from "./mensajes";
import axios from "axios";
import { validarFechas } from "../util/varios";

export const ReporteInspecciones = (props) => {
  const op = require("../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const fechaTope = moment(
    JSON.parse(localStorage.getItem("fechasistema"))
  ).format("YYYY-MM-DD");

  const btnCancela = useRef();
  const btnAcepta = useRef();
  const txtFechaDesde = useRef();
  const txtFechaHasta = useRef();
  const cmbMinas = useRef();

  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [minas, setMinas] = useState([]);

  const cargaragentesmina = () => {
    setActivate(true);

    let campos = `trim(nombre) as nombre, idagente, idtipoente`;
    let nomtab = "agente";
    let condi = `mina=true`;
    let orden = "idagente asc";

    let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?&campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setMinas(response.data);
        }
      })
      .catch(function (error) {
        console.error(error);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const onChangeValidar = () => {
    let sigue = true;

     if(txtFechaDesde.current.value === ""){
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "la fecha desde no puede estar vacia.",
        icono: "informacion",
      });
      sigue = false;
      txtFechaDesde.current.focus();  
     } else if(txtFechaHasta.current.value === ""){
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "la fecha hasta no puede estar vacia.",
        icono: "informacion",
      });
      sigue = false;
      txtFechaHasta.current.focus();
     } else if (!validarFechas(txtFechaDesde.current.value, txtFechaHasta.current.value)) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "la fecha desde no puede ser mayor a la fecha hasta.",
        icono: "informacion",
      });
      sigue = false;
     } 
     
     if (sigue) {
      imprimirReporte();
     }
    
  };
  const cancelar = (e) => {
    e.preventDefault();
    props.onHide();
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const imprimirReporte = () => {
    let desde = txtFechaDesde.current.value;
    let hasta = txtFechaHasta.current.value;
    let condi = cmbMinas.current.value !== "" ? ` AND i.idmina=${cmbMinas.current.value}` : "";
    
      window.open(
        `${op.reportesweb}reporte=ReporteInspec&CONDI=${condi}&DESDE=${desde}&HASTA=${hasta}`,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
      );
    
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        cargaragentesmina();
      }}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <Modal.Title style={{ color: "#fff" }}>Reporte de Inspecciones</Modal.Title>
        <button
          ref={btnCancela}
          style={{
            border: 0,
            margin: 0,
            padding: 0,
            color: "#ffffff",
            backgroundColor: "transparent",
          }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#FFF" }}>
        <div>
          <div className="row" style={{ fontFamily: "Times New Roman, Times, serif" }}>
            <div className="input-group input-group-sm col-sm-6">
                <label
                  className="input-group-text"
                  style={{ backgroundColor: "#55acee", fontSize: 12 }}
                  id="inputGroup-sizing-sm"
                >
                  Minas:
                </label>
                <select
                  name="idmina"
                  className="form-control"
                  ref={cmbMinas}
                >
                  <option value="">- todas -</option>
                  {minas &&
                    minas.map((item, i) => (
                      <option key={i} value={item.idagente}>
                        {item.nombre}
                      </option>
                    ))}
                </select>
            </div>
            <div className=" row col-sm-6 mx-auto">
                <div className="input-group input-group-sm col-sm-6">
                  <label className="input-group-text" style={{ backgroundColor: "#55acee", fontSize: 12 }} id="inputGroup-sizing-sm">
                    Desde:
                  </label>
                  <input
                    type="date"
                    name="fechadesde"
                    ref={txtFechaDesde}
                    className="form-control"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    max={fechaTope}
                    defaultValue={fechaTope}
                  />
                </div>
                <div className="input-group input-group-sm col-sm-6">
                  <label className="input-group-text" style={{ backgroundColor: "#55acee", fontSize: 12 }} id="inputGroup-sizing-sm">
                    Hasta:
                  </label>
                  <input
                    type="date"
                    name="fechahasta"
                    ref={txtFechaHasta}
                    className="form-control"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    max={fechaTope}
                    defaultValue={fechaTope}
                  />
                </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          ref={btnAcepta}
          onClick={onChangeValidar}
          className="btn btn-sm rounded-pill btn-success col-md-2"
        >
          <i className="fas fa-check-circle"> Aceptar</i>
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-danger btn-sm rounded-pill col-md-2"
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
      <Mensaje mensaje={mensaje} onHide={cerrarModal} />
      <Dimmer active={activate} />
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/modalinspeccionesreporte.js